module.exports = __webpack_public_path__ + "static/media/result_formation20.622465c0.png";